import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from '../auth/ProtectedRoute';
import { ROUTES, ROLES } from '../constants/routes';
import {
  NotFoundPage,
  SignInPage,
  ForgotPassword,
  UserTablePage,
  RegistrationPage,
  HomePage,
  AdminDashboard,
  AddStaff,
  AddStaffForm,
  StaffManagement,
  StaffLoginManagement,
  StudentListPage,
  StudentAttendance,
  EmployeeAttendence,
  Class,
  EmployeeAttendanceReport,
  AdmissionReport,
  AddStudent,
  StudentDocumentUpload,
  TransferPromoteStudent,
  ViewEditStudentDetails,
  AllComponents,
  VerifyOTP,
  AssignUserrole,
  Master,
  SubjectMapping,
  StudentProfile,
  ClassTimeTable,
  EditTimeTable,
  ProfilePage,
  SchoolProfilePage,
  StudentAttandanceReport,
  AssignSubjects,
  TimePeriodMaster,
  TeacherDashboard,
  AssignMenurole,
  ViewTimeTable,
  SidebarConfiguration,
  StaffProfile,
  CommunicationPanel,
  SupportTicketTable,
  SetupPage,
  StudentDashboard,
  FeeMaster,
  AssignFee,
  CollectFees,
  FeeReminder,
  EmployeeStudentAttendanceReport,
  EmployeeStudentAttendence,
  NoticeBoardPanel,
  AddHomework,
  TeacherLeaveTable,
  ApprovedLeaveRequest,
  MasterLeaveForm,
  HomeworkEvaluation,
  HomeworkReport,
  CreateNewExam,
  ExamScheduleTable,
  ExamAddUpdateTable,
  ResultReport,
  StudentHomework,
  StudentExamTimetable,
  StudentMarkSheet,
  ClassTeacher,
  MarkEmployeeAttendance,
  ReportEmployeeAttendance,
  Holidays,
  ParentDashboard,
  EmployeeDashboard,
  RouteManagement,
  VehicleManagement,
  StudentTransportAllocation,
  MyAttendanceReport,
  BulkDataUpload,
  SchoolSystemSetupWizard,
  PrivacyPolicy,
  TermsAndCondition,
  TransferReport,
  ExamMaster,
  FeeReport,
  StudentWiseFeeReport,
  MeetingCard,
  CreateMeetingDialog,
  MeetingDashboard,
  ClassWiseFeeReport,
  ExitGateMaster,
  GatePassVisitPurpose,
  GatePassList,
  GenerateIdCard,
  TrailEnded,
  FeeDueReport,
  FeeCollectionReport,
  FeeDueReportDetails,
  StudentAddmissionSetting,
  FeeCollectionReportDetails,
  InquiryStatusMaster,
  AddInquiry,
  InquiryDetails,
  SchoolPaymentGatewayPage,
  GenerateMarkSheets, BiometricRegistration, OfflineFeeVerification, PaymentSettingPage,
  ParentKidFee,
  StudentFeeAssign,
  CreateHostel,
  AddRoomType,
  AddHostelRoom,
  StudentHostelAllocation,
  GenerateAdmitCard,
  FeeCollectionPage,
  CollectFeeDetailsPage,
  StopManagement,
  TransportFee,
  AddSubject,
  SchoolAnalytics,
  ColScholasticExam,
  AssignAdditionalSubject,
  SessionSetting,
  Marksheets,
  CollectFeeDetailsPageParent,
  NewTimeTableClass,
  PromoteStudent,
  ONBOARDING,
  OnboardingTabs
  , ExamMapping,
  BulkExamMarks,
  AddInstitute,
  DesignationRole,
  HostelMaster,
  HostelFee,
  ManageLogin,
  AdvancedVehicleTracking,
  BulkStudent,
  VehicleHistory,
  GenerateCertificate,
  CertificateGenerator,
  ExpenseHead,
  ExpenseMaster,
  SyllabusDetails,
  SyllabusMaster,
  StudentSyllabus,
  RemoteSupportGuidePage,
  VehicleHistoryMapPage,
  ExamSubjectsAnalytics,
  BulkAttendanceUpdate,
  TransferCertificate,
  PreviousFeeCollectPage,
  PayrollMastr,
  PayrollSlip,
  PayrollRun,
  StaffBUlkAttendance,
  CertificateTableUI,
  AdvanceSalary,
  HouseMaster,
  HouseDetail,
  StudentReportTable,
  FinanceSummary,
  DiscountReport,
  DiscountDetails,
  ReceiptsDownload,
  WhatsAppSettings,
  LedgerStudentWise,
  UserAccess,
  CertificateStudio,
  CreateAdmitCard,
  CreateAdmitCardNew,
  GenerateAdmitcardNew,
  StudentAdmitCard,
  MoveStudentList,
  PettyCash,
  PettyLedger,
  PettyClosing,
  EmployeePunchInOutReport,
  Reports,
  MyIssuedCertificates,
  ExamPublish,
  AuditLog,
  BulkExamMarksUpload,
  TwoAuthentication,
  MarksheetSettings,
} from './LazyComponents';
import { Suspense } from 'react';
import ThemeSettingPage from '../pages/GeneratSettings/ThemeSettingPage';
import MeetingRoom from '../pages/OnlineClasses/MeetingRoom';
import WhatsAppSetting from '../pages/GeneratSettings/WhatsAppSetting';
import TwoAuthenticationPage from '../components/HeaderYearDropdown/TwoAuthenticationPage';
import { useAuth } from '../hooks/useAuth';

// const Loader = () => <div>Loading...</div>;

const AppRoutes = () => {
  const { user } = useAuth();
 
  // <Suspense fallback={<Loader />}>
  return (
  <Suspense>
    <Routes>
      <Route path={ROUTES.STUDENTSIGNIN} element={<TwoAuthenticationPage  />} />
      <Route path={ROUTES.PARENTSIGNIN} element={<TwoAuthenticationPage />} />
      <Route path={ROUTES.EMPLOYEESIGNIN} element={<TwoAuthenticationPage />} />
      <Route path={ROUTES.ADMINSIGNIN} element={<TwoAuthenticationPage />} />
      <Route path={ROUTES.FORGOTPASSWORD} element={<ForgotPassword />} />
      <Route path={ROUTES.ADMINFORGOTPASSWORD} element={<ForgotPassword />} />
      <Route path={ROUTES.EMPLOYEEFORGOTPASSWORD} element={<ForgotPassword />} />
      <Route path={ROUTES.PARENTFORGOTPASSWORD} element={<ForgotPassword />} />
      <Route path={ROUTES.REGISTRATION} element={<RegistrationPage />} />
      <Route path={ROUTES.PRIVACYPOLICY} element={<PrivacyPolicy />} />
      <Route path={ROUTES.TERMS} element={<TermsAndCondition />} />
      <Route path={ROUTES.STUDENTFEEDUEREPORT} element={<FeeDueReportDetails />} />
      <Route path={ROUTES.CREATEHOSTEL} element={<CreateHostel />} />
      <Route path={ROUTES.ADDROOMTYPE} element={<AddRoomType />} />
      <Route path={ROUTES.ADDHOSTELROOM} element={<AddHostelRoom />} />
      <Route path={ROUTES.STUDENTHOSTELALLOCATION} element={<StudentHostelAllocation />} />
      <Route path={ROUTES.STUDENTEXAMTIMTABLE} element={<StudentExamTimetable />} />
      <Route path={ROUTES.STUDENTMARKSHEET} element={<StudentMarkSheet />} />
       <Route path={ROUTES.TWOAUTHENTICATION} element={<TwoAuthentication />} />
      {/* <Route path={ROUTES.REMOTE} element={<UserTablePage />} /> */}
      <Route
        element={
          <ProtectedRoute
            allowedRoles={[ROLES.ADMIN, ROLES.DIRECTOR, ROLES.EMPLOYEE, ROLES.TEACHER, ROLES.PARENT, ROLES.STUDENT, ROLES.SUPERDIRECTOR]}
          />
        }
      >
        <Route path={ROUTES.HOME} element={<HomePage />} />
        <Route path={ROUTES.ADMINDASHBOARD} element={<AdminDashboard />} />
        <Route path={ROUTES.DASHBOARD} element={<UserTablePage />} />
        <Route path={ROUTES.STAFF_ADD} element={<AddStaff />} />
        <Route path={ROUTES.STAFFADDFORM} element={<AddStaffForm />} />
        <Route path={ROUTES.TIMEPERIODMASTER} element={<TimePeriodMaster />} />
        <Route path={ROUTES.ROUTEMANAGEMENT} element={<RouteManagement />} />
        <Route path={ROUTES.VEHICLEMANAGEMENT} element={<VehicleManagement />} />
        <Route path={ROUTES.STUDENTTRANSPORTALLOCATION} element={<StudentTransportAllocation />} />
        <Route path={ROUTES.ASSIGNSUBJECTS} element={<AssignSubjects />} />
        <Route path={ROUTES.DESIGNATIONROLE} element={<DesignationRole />} />
        <Route path={ROUTES.ADDSTUDENT} element={<AddStudent />} />
        <Route path={ROUTES.STUDENTDOCUMENT} element={<StudentDocumentUpload />} />
        <Route path={ROUTES.PROMOTESTUDENT} element={<TransferPromoteStudent />} />
        <Route path={ROUTES.SYSTEMSETUPSCHOOL} element={<SchoolSystemSetupWizard />} />
        <Route path={ROUTES.EDITSTUDENT} element={<ViewEditStudentDetails />} />
        <Route path={ROUTES.STUDENTREPORT} element={<StudentReportTable />} />
        <Route path={ROUTES.TRIALENDED} element={<TrailEnded />} />
          
        <Route path={ROUTES.STAFF_MANAGE} element={<StaffManagement />} />
        <Route path={ROUTES.STAFF_LOGIN} element={<StaffLoginManagement />} />
        <Route path={ROUTES.SIDEBARCONFIGURATION} element={<SidebarConfiguration />} />
        <Route path={ROUTES.ASSIGNMENUROLE} element={<AssignMenurole />} />
        <Route path={ROUTES.BULKSTUDENT} element={<BulkStudent />} />
        <Route path={ROUTES.ASSIGNUSERROLE} element={<AssignUserrole />} />
        <Route path={ROUTES.LEADERSTUDENTWISE} element={<LedgerStudentWise />} />
        <Route path={ROUTES.USERACCES} element={<UserAccess />} />
        <Route path={ROUTES.STUDENTTABLE} element={<StudentListPage />} />
        <Route path={ROUTES.STUDENTATTENDANCE} element={<StudentAttendance />} />
        <Route path={ROUTES.EMPLOYEEATTENDANCE} element={<MarkEmployeeAttendance />} />
        {/* <Route path={ROUTES.EMPLOYEEATTENDENCE} element={<EmployeeAttendence />} /> */}
        <Route path={ROUTES.CLASS} element={<Class />} />

        <Route path={ROUTES.MASTER} element={<Master />} />
        <Route path={ROUTES.SUBJECTMAPPING} element={<SubjectMapping />} />
        <Route path={ROUTES.EMPLOYEEATTENDANCEREPORT} element={<ReportEmployeeAttendance />} />
        <Route path={ROUTES.ADMISSIONREPORT} element={<AdmissionReport />} />
        <Route path={ROUTES.STUDENTPROFILE} element={<StudentProfile />} />
        <Route path={ROUTES.STAFFPROFILE} element={<StaffProfile />} />
        <Route path={ROUTES.ALLCOMPONENTS} element={<AllComponents />} />
        {/* <Route path={ROUTES.MANAGECLASSES} element={<Manageclasses />} /> */}
        <Route path={ROUTES.PROFILEPAGE} element={<ProfilePage />} />
        <Route path={ROUTES.AUDITLOG} element={<AuditLog />} />
        <Route path={ROUTES.SCHOOLPROFILE} element={<SchoolProfilePage />} />
        <Route path={ROUTES.STUDENTATTENDENCEREPORT} element={<StudentAttandanceReport />} />
        <Route path={ROUTES.TEACHERDASHBOARD} element={<TeacherDashboard />} />
        <Route path={ROUTES.COMMUNICATIONPANEL} element={<CommunicationPanel />} />
        <Route path={ROUTES.NOTICEBOARDPANEL} element={<NoticeBoardPanel />} />
        <Route path={ROUTES.TEACHERLEAVE} element={<TeacherLeaveTable />} />
        <Route path={ROUTES.LEAVEAPPROVIDEREQUEST} element={<ApprovedLeaveRequest />} />
        <Route path={ROUTES.MASTERLEAVEFORM} element={<MasterLeaveForm />} />
        <Route path={ROUTES.CREATENEWEXAM} element={<CreateNewExam />} />
       
        <Route path={ROUTES.EXAMSCHEDULETABLE} element={<ExamScheduleTable />} />
        <Route path={ROUTES.EXAMADDUPDATETABLE} element={<ExamAddUpdateTable />} />
        <Route path={ROUTES.BULKEXAMADDUPDATETABLE} element={<BulkExamMarks />} />
        <Route path={ROUTES.BULKATTENDANCEUPDATE} element={<BulkAttendanceUpdate />} />
        <Route path={ROUTES.RESULTREPORT} element={<ResultReport />} />
        <Route path={ROUTES.CREATETICKET} element={<SupportTicketTable />} />
        <Route path={ROUTES.REMOTESUPPORT} element={<RemoteSupportGuidePage />} />
        <Route path={ROUTES.SETUPPAGE} element={<SetupPage />} />
        <Route path={ROUTES.STUDENTDASHBOARD} element={<StudentDashboard />} />
        <Route path={ROUTES.CLASSTIMETABLE} element={<ClassTimeTable />} />
        <Route path={ROUTES.TIMETABLE} element={<EditTimeTable />} />
        <Route path={ROUTES.VIEWTIMETABLE} element={<ViewTimeTable />} />
        <Route path={ROUTES.THEMESETTINGPAGE} element={<ThemeSettingPage />} />
        <Route path={ROUTES.FEEMASTER} element={<FeeMaster />} />
        <Route path={ROUTES.ASSIGNFEE} element={<AssignFee />} />
        <Route path={ROUTES.COLLECTFEE} element={<CollectFees />} />
        <Route path={ROUTES.FEEREMINDER} element={<FeeReminder />} />
        <Route path={ROUTES.CLASSTEACHER} element={<ClassTeacher />} />
        <Route path={ROUTES.EMPLOYEESTUDENTATTENDENCE} element={<EmployeeStudentAttendence />} />
        <Route
          path={ROUTES.EMPLOYEESTUDENTATTENDANCEREPORT}
          element={<EmployeeStudentAttendanceReport />}
        />
        <Route path={ROUTES.ADDHOMEWORK} element={<AddHomework />} />
        <Route path={ROUTES.HOMEWORKEVALUATION} element={<HomeworkEvaluation />} />
        <Route path={ROUTES.HOMEWORKREPORT} element={<HomeworkReport />} />
        <Route path={ROUTES.STUDENTHOMEWORK} element={<StudentHomework />} />
        <Route path={ROUTES.HOLIDAYS} element={<Holidays />} />
        <Route path={ROUTES.PARENTDASHBOARD} element={<ParentDashboard />} />
        <Route path={ROUTES.EMPLOYEEDASHBOARD} element={<EmployeeDashboard />} />
        <Route path={ROUTES.MYATTENDANCEREPORT} element={<MyAttendanceReport />} />
        <Route path={ROUTES.BULKDATAUPLOAD} element={<BulkDataUpload />} />
        <Route path={ROUTES.TCREPORT} element={<TransferReport />} />
        <Route path={ROUTES.EXAMMASTER} element={<ExamMaster />} />
        <Route path={ROUTES.FEESREPORT} element={<FeeReport />} />
        <Route path={ROUTES.CLASSFEESREPORT} element={<ClassWiseFeeReport />} />

        <Route path={ROUTES.HOSTMEETING} element={<MeetingDashboard />} />
        <Route path={ROUTES.ONBOARDING} element={<OnboardingTabs />} />
        <Route path="/meeting/:meetingId" element={<MeetingRoom />} />
        <Route path={ROUTES.GATEPASS} element={<ExitGateMaster />} />
        <Route path={ROUTES.VISITPASS} element={<GatePassVisitPurpose />} />
        <Route path={ROUTES.GATEPASSlIST} element={<GatePassList />} />
        <Route path={ROUTES.GENERATEIDCARD} element={<GenerateIdCard />} />
        <Route path={ROUTES.GENERATCERTIFICATE} element={<GenerateCertificate />} />
        <Route path={ROUTES.STUDENTADDMISSIONSETTING} element={<StudentAddmissionSetting />} />
        <Route path={ROUTES.FEEDUEREPORT} element={<FeeDueReport />} />
        <Route path={ROUTES.FEECOLLECTIONREPORT} element={<FeeCollectionReport />} />
        <Route path={ROUTES.FINACESUMMARY} element={<FinanceSummary />} />
        <Route path={ROUTES.DISCOUNTREPORT} element={<DiscountReport />} />
        <Route path={ROUTES.PETTYCASH} element={<PettyCash />} />
        <Route path={ROUTES.REPORTS} element={<Reports />} />
        <Route path={ROUTES.PETTYLEDGER} element={<PettyLedger />} />
        <Route path={ROUTES.PETTYCLOSING} element={<PettyClosing />} />

        <Route path={ROUTES.STUDENTFEECOLLECTIONREPORT} element={<FeeCollectionReportDetails />} />
        <Route path={ROUTES.DISCOUNTDETAILS} element={<DiscountDetails />} />
        <Route path={ROUTES.INQSTATUSMASTER} element={<InquiryStatusMaster />} />
        <Route path={ROUTES.ADDINQUIRY} element={<AddInquiry />} />
        <Route path={ROUTES.INQUIRYDETAILPAGE} element={<InquiryDetails />} />
        {/* <Route path={ROUTES.WHASAPPSETTING} element={<WhatsAppSetting />} /> */}
        <Route path={ROUTES.BIOMETRICREGISTRATION} element={<BiometricRegistration />} />
        <Route path={ROUTES.MARKSHEETSAMPLE} element={<GenerateMarkSheets />} />

        <Route path={ROUTES.OFFLINEFEEVERIFICATION} element={<OfflineFeeVerification />} />
        <Route path={ROUTES.PAYMENTGATEWAYPAGE} element={<PaymentSettingPage />} />
        <Route path={ROUTES.PARENTKIDFEES} element={<ParentKidFee />} />
        <Route path={ROUTES.STUDENTFEEASSIGN} element={<StudentFeeAssign />} />
        {/* <Route path={ROUTES.GENERATEADMITCARD} element={<GenerateAdmitCard />} /> */}
        <Route
  path={ROUTES.GENERATEADMITCARD}
  element={
    ROLES.STUDENT
      ? <StudentAdmitCard />
      : <GenerateAdmitCard />
  }
/>
        <Route path={ROUTES.CREATEADMITCARD} element={<CreateAdmitCard />} />
        <Route path={ROUTES.GENERATEADMITCARDNEW} element={<GenerateAdmitcardNew />} />
        <Route path={ROUTES.EXAMPUBLISH} element={<ExamPublish />} />
        <Route path={ROUTES.COLLECTFEENEW} element={<FeeCollectionPage />} />
        <Route path={ROUTES.COLLECTFEEDETAILSNEW} element={<CollectFeeDetailsPageParent />} />
        <Route path={ROUTES.STOPMANAGEMENT} element={<StopManagement />} />
        <Route path={ROUTES.TRANSPORTFEE} element={<TransportFee />} />
        <Route path={ROUTES.ADDSUBJECT} element={<AddSubject />} />
        <Route path={ROUTES.SCHOOLANALYTICS} element={<SchoolAnalytics />} />
        <Route path={ROUTES.COLSCHOLASTICEXAM} element={<ColScholasticExam />} />
        <Route path={ROUTES.ASSIGNADDITIONALSUBJECT} element={<AssignAdditionalSubject />} />
        <Route path={ROUTES.SESSIONSETTING} element={<SessionSetting />} />

        <Route path={ROUTES.MARKSHEETS} element={<Marksheets />} />
        <Route path={ROUTES.CUSTOMTIMETABLE} element={<NewTimeTableClass />} />
        <Route path={ROUTES.PROMOTESTUDENTNEW} element={<PromoteStudent />} />
        <Route path={ROUTES.EXAMMAPPING} element={<ExamMapping />} />
        <Route path={ROUTES.EXAMSUBJECTSANALYTICS} element={<ExamSubjectsAnalytics />} />
        <Route path={ROUTES.ADDINSTITUTE} element={<AddInstitute />} />
        <Route path={ROUTES.HOSTELMASTER} element={<HostelMaster />} />
        <Route path={ROUTES.HOSTELFEE} element={<HostelFee />} />
        <Route path={ROUTES.MANAGELOGINS} element={<ManageLogin />} />
        <Route path={ROUTES.VEHICLETRACKING} element={<AdvancedVehicleTracking />} />
        <Route path={ROUTES.VEHICLETRACKINGHISTORYMAP} element={<VehicleHistoryMapPage />} />
        <Route path={ROUTES.EXPENSE} element={<ExpenseHead />} />
        <Route path={ROUTES.EXPENSEMASTER} element={<ExpenseMaster />} />
        <Route path={ROUTES.PAYROLLMASTER} element={<PayrollMastr />} />
        <Route path={ROUTES.PAYSLIP} element={<PayrollSlip />} />
        <Route path={ROUTES.PAYSLIPRUN} element={<PayrollRun />} />
        <Route path={ROUTES.BULKATTENDANCE} element={<StaffBUlkAttendance />} />
        <Route path={ROUTES.ADVANCESALARY} element={<AdvanceSalary />} />
        <Route path={ROUTES.SYLLABUSMASTER} element={<SyllabusMaster />} />
        <Route path={ROUTES.SYLLABUSDETAILS} element={<SyllabusDetails />} />
        <Route path={ROUTES.STUDENTSYLLABUS} element={<StudentSyllabus />} />
        <Route path={ROUTES.GENERATETC} element={<TransferCertificate />} />
        <Route path={ROUTES.ADDDUE} element={<PreviousFeeCollectPage />} />
        <Route path={ROUTES.CERTIFICATEMASTER} element={<CertificateTableUI />} />
        <Route path={ROUTES.CREATECERTIFICATE} element={<CertificateStudio />} />
        <Route path={ROUTES.RECEIPTSDOWNLOAD} element={<ReceiptsDownload />} />
        <Route path={ROUTES.HOUSEMASTER} element={<HouseMaster />} />
        <Route path={ROUTES.HOUSEVIEWDETAIL} element={<HouseDetail />} />
        <Route path={ROUTES.WHASAPPSETTING} element={<WhatsAppSettings />} />
              <Route path={ROUTES.MOVESTUDENTLIST} element={<MoveStudentList/>} />
               <Route path={ROUTES.EMPLOYEEPUNCHINOUTREPORT} element={<EmployeePunchInOutReport />} />
               <Route path={ROUTES.ISSUEDCERTIFICATE} element={<MyIssuedCertificates />} />
        <Route path={ROUTES.BULKEXAMMARKSUPLOAD} element={<BulkExamMarksUpload />} />
        <Route path={ROUTES.MARKSHEETSETTING} element={<MarksheetSettings />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  </Suspense>
)
};

export default AppRoutes;
